import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './Styles.jsx'
import {
  Button,
  Container,
  // Divider,
  // Grid,
  // Header,
  Icon,
  // Image,
  // List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  // Visibility,
} from 'semantic-ui-react'
import HomepageHeading from './Head.jsx'
import MenuItems from './MenuItems'


class MobileContainer extends Component {
  state = {}

  handleToggle = () => this.setState({ sidebarOpened: !this.state.sidebarOpened })

  render() {
    const { children } = this.props
    const { sidebarOpened } = this.state

    return (
      <Responsive  maxWidth={768}>
      <section id='home'>
        <Sidebar.Pushable>
          <Sidebar as={Menu} animation='uncover' inverted vertical visible={sidebarOpened}>
            <MenuItems />
          </Sidebar>

          <Sidebar.Pusher dimmed={sidebarOpened} onClick={this.handleToggle} style={{ minHeight: '10vh' }}>
            <Segment inverted textAlign='center' style={{ minHeight: 360, padding: '1em 0em', background: 'center center no-repeat', backgorundSize: 'cover', backgroundImage: 'url(img/header-bg.jpg)' }} vertical>
              <Container>
                <Menu inverted pointing secondary size='large'>
                  <Menu.Item onClick={this.handleToggle}>
                    <Icon name='sidebar' />
                  </Menu.Item>
                  <Menu.Item position='right' style={styles.menuItem}>
                    <Button as='a' inverted style={styles.menuItem}>Rown Arts</Button>
                  </Menu.Item>
                </Menu>
              </Container>
              <HomepageHeading mobile />
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        </section>
        {children}
      </Responsive>
    )
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
}


export default MobileContainer


// WEBPACK FOOTER //
// ./src/components/MobileContainer.jsx